<div [id]="ariaId" class="SuggestionsListElement" [ngClass]="isSelected ? 'SuggestionsListElement--focused' : ''" (mousedown)="itemClicked()" [attr.aria-selected]="isSelected" 
role="option" aria-selected="isSelected">
	<div class="SuggestionsListElement__icon" [ngClass]="TRAFFICNODE_TYPE[trafficNode.type]"></div>
	<div class="SuggestionsListElement__text"> {{ trafficNode.city }}, {{ trafficNode.name }} </div>
</div>
